
//系统目录 / 变化明细表 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

/**
 * 
 * get 
 *  
 */


// 查询展示西药库调价信息-分页
export const chgDetailsPage = (data) => {
    return request.post("/outpatient/dgsDpurcAdjust/selAdjustInfo", data)
}
// 查询展示卫材库调价信息-分页
export const chgDetailsWCPage = (data) => {
    return request.post("/outpatient/eisaiTable/eisaiPageList", data)
}
// 查询展示西药房调价信息-分页
export const chgYFDetailsPage = (data) => {
    return request.post("/outpatient/dugDpurcAdjust/selAdjustDugInfo", data)
}
// 快速调整西药库成本单价和销售单价
export const adjustFastPric = (data) => {
    return request.post("/outpatient/dgsDpurcAdjust/adjustFastPric", data)
}
// 快速调整卫材库成本单价和销售单价
// export const adjustFastPric = (data) => {
//     return request.post("/outpatient/dgsDpurcAdjust/adjustFastPric", data)
// }
// 快速调整西药房成本单价和销售单价
export const adjustYFFastPric = (data) => {
    return request.post("/outpatient/dugDpurcAdjust/adjustDugFastPric", data)
}

// 查询展示中药库调价信息-分页
export const chgZYDetailsPage = (data) => {
    return request.post("/outpatient/dgsDpurcTcmAdjust/selAdjustTcmInfo", data)
}
// 查询展示中药房调价信息-分页
export const chgZYFDetailsPage = (data) => {
    return request.post("/outpatient/dugDpurcTcmAdjust/selAdjustTcmDugInfo", data)
}
// 快速调整中药库成本单价和销售单价
export const adjustZYastPric = (data) => {
    return request.post("/outpatient/dgsDpurcTcmAdjust/adjustTcmFastPric", data)
}
// 快速调整中药房成本单价和销售单价
export const adjustZYFFastPric = (data) => {
    return request.post("/outpatient/dugDpurcTcmAdjust/adjustTcmDugFastPric", data)
}
/*
 * 
 * DELETE 
 *   
 */   

// 暴露
export default{
	chgDetailsPage,adjustFastPric
}